import React from 'react';
import { useAppContext } from 'src/components/app-context';
import { TitleMediumText } from '@prisjakt/ui/text/variants';
import { ColorVariantSelectionButton } from './color-variant-selection-button';
import { useOfferListFilterContext } from 'src/areas/product/components/offer-list-filter-context';
import { FilterType } from 'src/components/price-list/types';
import { IVariantsProps } from '../types';
import {
  VariantGridTitle,
  VariantGridHeader,
  ScrollableArea,
} from '../styles-common';
import { VariantGridWrapper, VariantGridCell } from './styles';

export const ColorVariantsGrid: React.FC<IVariantsProps> = props => {
  const { title, variants, handleSelection, isMobile } = props;
  const { t } = useAppContext();
  const { getFilter } = useOfferListFilterContext();
  const filter = getFilter(FilterType.VARIANT_COLOR);
  const selection = filter?.active ? filter?.selection : undefined;
  const sortedVariants = variants?.filter(Boolean);

  return (
    <div>
      {title && (
        <VariantGridHeader>
          <VariantGridTitle>
            <TitleMediumText>{title}</TitleMediumText>
          </VariantGridTitle>
        </VariantGridHeader>
      )}
      <ScrollableArea>
        <VariantGridWrapper>
          <VariantGridCell $order={0}>
            <ColorVariantSelectionButton
              variant={null}
              title={t('product', 'variants.all')}
              selection={selection}
              handleSelection={handleSelection}
              isMobile={isMobile}
            />
          </VariantGridCell>
          {sortedVariants?.map(variant => (
            <ColorVariantSelectionButton
              variant={variant.color!}
              selection={selection}
              handleSelection={handleSelection}
              disabled={variant.disabled}
              key={variant.color}
              isMobile={isMobile}
            />
          ))}
        </VariantGridWrapper>
      </ScrollableArea>
    </div>
  );
};
